<div  *ngFor='let it of ghosts' 
          class='user' style="width:100%"> 
      <div class="avatar"></div>
      <div class="lines">
        <h2></h2>
        <h3></h3>
        <!-- <p></p> -->
      </div>
    </div> 
